import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root'
})
export class EventosService {
    constructor(public http: HttpClient) {}

    getEvents() {
        let data = {
            id_proyecto: sessionStorage.getItem('IdSelectProject')
        }
        let url = environment.URL_SERVICIOS + 'getAllEvents'
        return this.http.post(url, data).pipe(
            map((resp: any) => {
                return resp
            })
        )
    }
}
